var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'rejectreason-edit',
  created () {
    this.search()
  },
  data () {
    return {
      contentCount: 0,
      canValidate: true
    }
  },
  computed: {
    rejectReason () {
      return this.$store.getters.edit_reject_reason
    },
    loading () {
      return this.$store.getters.apiLoading
    },
    validation: function() {
      var v = {
        reject_reason: !!this.rejectReason.data.attributes['reject-reason'],
        reject_reason_default_content: !!this.rejectReason.data.attributes['reject-reason-default-content'],
        reject_reason_priority: !!this.rejectReason.data.attributes['reject-reason-priority'],
        not_input: !!this.rejectReason.data.attributes['reject-reason'] &&
                   !!this.rejectReason.data.attributes['reject-reason-default-content'] &&
                   !!this.rejectReason.data.attributes['reject-reason-priority']
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true; });
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    }

  },
  components: {
    AppHeader
  },
  methods: {
    onClickSave: function () {
      this.canValidate = true
      if (this.isValid) {
        console.log("is valid")
        var data = {
          reject_reason: this.rejectReason.data.attributes['reject-reason'],
          reject_reason_default_content: this.rejectReason.data.attributes['reject-reason-default-content'],
          reject_reason_priority: this.rejectReason.data.attributes['reject-reason-priority']
        }
        this.$store.dispatch('REJECT_REASON_UPDATE', { id: this.$route.params.id, data: data, callback: this.onSaved })
      }else{
        console.log("need edit")
      }
    },
    onClickCancel: function () {
      this.$router.push({ path: '/reject_reasons', query: { type: this.$router.currentRoute.query.type}})
    },
    search: function() {
      var data = {}
      var self = this
      data.callback = function () {
        self.contentCounter()
      }
      this.$store.dispatch('REJECT_REASON_EDIT',  {id: this.$route.params.id, data: data})
    },
    half: function () {
      this.rejectReason.data.attributes['reject-reason'] = utils.emHalf(this.rejectReason.data.attributes['reject-reason'])
    },
    onSaved: function (result) {
      this.$router.push({ path: '/reject_reasons/'})
    },
    contentCounter: function() {
      this.rejectReason.data.attributes['reject-reason-default-content'] = utils.emHalf(this.rejectReason.data.attributes['reject-reason-default-content'])
      this.contentCount = this.rejectReason.data.attributes['reject-reason-default-content'].length
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/rejectreason-edit.js